import humps from 'lodash-humps-ts';
import { snakes } from '@utils/lodash';
import { authAxios } from '@components/Auth';
import { API_V1_BASE } from '@config';
import { CorporateHealthOrder } from '@models/CorporateHealthOrder';
import { WithParams } from '@utils/typescript';
import { CorporateHealthOrderUserRemainingBenefit } from '@models/CorporateHealthOrderUserRemainingBenefit';
import { CorporateUser } from '@models/User';
import { paginate, Pagination, PaginationParams } from '@models/Pagination';

export type GetCorporateHealthOrderUsersParams = PaginationParams & WithParams<{
  search: string;
  policyNumber: string;
}>;

export type GetCorporateHealthOrderUserParams = WithParams<{
  name: string;
  policyNumber: string;
}>;

export type GetCorporateHealthOrderParams = WithParams<{
  id: number;
}>;

export type GetCorporateHealthOrderByUsernameParams = WithParams<{
  id: number;
  username: string;
}>;

export type GetCorporateUserByUsernameParams = GetCorporateHealthOrderByUsernameParams;
export type GetCorporateHealthOrderUserRemainingBenefitsParams = GetCorporateHealthOrderByUsernameParams;

export class CorporateHealthOrderApi {
  static getAll = async () => {
    return await authAxios
      .get(`${API_V1_BASE}/user/corporate_health_orders`)
      .then((response) => humps(response.data) as CorporateHealthOrder[]);
  };

  static get = async ({ id }: GetCorporateHealthOrderParams) => {
    return await authAxios
      .get(`${API_V1_BASE}/user/corporate_health_orders/${encodeURIComponent(id)}`)
      .then((response) => humps(response.data) as CorporateHealthOrder);
  };

  static getUsers = async (params: GetCorporateHealthOrderUsersParams) => {
    return await authAxios
      .get(`${API_V1_BASE}/user/corporate_health_orders/search_users`, { params: snakes(params) })
      .then((response) => paginate(response) as [CorporateHealthOrder[], Pagination]);
  };

  static findUser = async (params: GetCorporateHealthOrderUserParams) => {
    return await authAxios
      .get(`${API_V1_BASE}/user/corporate_health_orders/find_user`, { params: snakes(params) })
      .then((response) => humps(response.data) as CorporateUser);
  };

  static findByUsername = async ({ id, username }: GetCorporateHealthOrderByUsernameParams) => {
    return await authAxios
      .get(`${API_V1_BASE}/user/corporate_health_orders/${encodeURIComponent(id)}/find_by_username`, {
        params: { username: username }
      })
      .then((response) => humps(response.data) as CorporateHealthOrder);
  };

  static findUserByUsername = async ({ id, username }: GetCorporateUserByUsernameParams) => {
    return await authAxios
      .get(`${API_V1_BASE}/user/corporate_health_orders/${encodeURIComponent(id)}/users/${username}`)
      .then((response) => humps(response.data) as CorporateUser);
  };

  static getCorporateHealthOrderUserRemainingBenefits = async ({ id, username }: GetCorporateHealthOrderUserRemainingBenefitsParams) => {
    return await authAxios
      .get(`${API_V1_BASE}/user/corporate_health_orders/${encodeURIComponent(id)}/users/${username}/remaining_benefits`)
      .then((response) => humps(response.data) as CorporateHealthOrderUserRemainingBenefit[]);
  }
}
